module.exports = __webpack_public_path__ + "static/media/PictoClock.adeb68b9.svg";